import styled from "styled-components";
import { colors } from "../../../theme/color";
import fipayFonts from "../../../theme/index";
import TextFields, {
  DropDownTextField,
} from "../../../components/TextField/text-field.component";
import { InputField } from "../../../components/TextField/text-field.styles";

export const AddNewProductModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20000;
  backdrop-filter: blur(2px);
`;

export const AddNewProductModalContainer = styled.div`
  width: 50%;
  height: 87vh;
  overflow-y: scroll;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 1024px) {
    width: 60%;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    max-height: 90vh;
  }
`;

export const AddNewProductModalHeader = styled.div`
  height: 115px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${colors.PRIMARY_GREY};
`;

export const AddNewProductModalDetails = styled.div`
  margin-left: 35px;
`;

export const AddNewProductCloseButton = styled.button`
  background-color: ${colors.White};
  border: none;
  font-size: 18px;
  // cursor: pointer;
  margin-right: 40px;
  border: 1px solid #e8eaed;
  border-radius: 50%;
  padding: 4px;
  width: 30px;
  height: 30px;
`;

export const AddNewProductModalHeaderText = styled.h4`
  font-size: ${fipayFonts.fipayFonts.fontSize.body1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
`;

export const AddNewProductModalUnderText = styled.p`
  margin-top: -15px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  color: ${colors.SECONDARY_GREY};
`;

export const AddNewProductModalBody = styled.div`
  display: flex;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const AddNewProductModalLeftSection = styled.div`
  flex: 60%;
  padding: 20px;
  margin-top: 20px;
`;

export const AddNewProductModalRightSection = styled.div`
  flex: 40%;
  padding: 5px;
`;

export const AddNewProductModalInputContainer = styled.div`
  margin-top: -20px;
  // border: 2px solid red;
`;

export const ProductDesLabel = styled.div`
  margin-bottom: 5px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
`;

export const AddNewProductModalInputContainer1 = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  //   margin-top: -20px;
  //   margin-left: -55px;
`;

export const AddNewProductModalInputContainer2 = styled.div`
  width: 96%;
  padding-left: 11px;
  padding-bottom: 15px;
`;

export const AddNewProductModalDropWrap = styled.div`
  width: 50%;
  margin-left: -20px;
`;

export const AddNewProductModalMaxQuan = styled.h5`
  margin-left: 60px;
`;

export const AddProductStyledDropDownTextField = styled(DropDownTextField)`
  width: 52px;
  height: 30px;
  border-radius: 2px;

  box-sizing: border-box;
`;

export const StyledTextField = styled(InputField)`
  width: 50%;
  height: 50px;
  margin-top: -20px;
  resize: vertical;
  overflow: auto;
  border: 2px solid red;
  background-color: yellow;
`;

export const AddNewProductModalInputContainerTwo = styled.div`
  margin-right: 10px;
`;

export const AddProductImageLabelCon = styled.div`
  margin-right: 10px;
  padding-top: 27px;
`;

export const AddNewProductModalImageContainer = styled.div<{
  hoverText?: string;
  hasImage: boolean;
  isHovered: boolean;
}>`
  width: 80%;
  padding-left: 10px;
  padding-top: 5px;
  position: relative;

  // background-color: ${(props) =>
    props.isHovered ? "rgba(0, 0, 0, 0.5)" : "transparent"};

  &:hover::before {
    content: "${({ hoverText, hasImage }) =>
      hoverText && !hasImage ? hoverText : ""}";

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: white;
    font-weight: 600;
    text-align: center;

    z-index: 1;
    cursor: pointer;
  }

  &:hover img {
    cursor: pointer;
    z-index: 0;
    background-color: none;
  }
`;

export const AddNewProductModalImg = styled.img`
  width: 100%;
  height: auto;
  border: 1px solid #e8eaed;
  border-radius: 10px;

  &:hover {
    cursor: pointer;
    background-color: transparent;
  }
`;

export const AddProductImgLabel = styled.label`
  padding-left: 10px;
  padding-bottom: 20px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
`;

export const AddNewProductModalButtonContainer = styled.div`
  display: flex;
  margin-top: 340px;
  margin-left: -40px;
  height: 70px;

  @media screen and (max-width: 768px) {
    margin-top: 15px;
    margin-left: 2px;
  }
`;

export const AddNewProductButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-left: -10px;
`;

export const AddNewProductButtonContainer1 = styled.div`
  display: flex;
  justify-content: center;
  width: 70%;
  margin-right: 30px;
`;

export const AddNewProductPriceType = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -10px;
  margin-left: 20px;
`;

export const AddProductCardRadioButton = styled.div`
  width: 70%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-left: 0px;
`;

export const AddNewProductSelect = styled.p`
  color: ${colors.DARK_GRAY};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
`;

export const AddNewProductLabel = styled.label`
  width: 40%;
  margin-left: 5px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
`;

export const RadioButton = styled.input.attrs({ type: "radio" })`
  margin-left: auto;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  position: relative;

  &::before {
    content: "";
    display: inline-block;
    width: ${(props) => (props.checked ? "4px" : "16px")};
    height: ${(props) => (props.checked ? "4px" : "16px")};
    border: 2px solid ${(props) => (props.checked ? "#69c914" : "#CFCFCFCF")};
    border-radius: 50%;
    margin-right: 10px;
    vertical-align: middle;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    background-color: ${(props) => (props.checked ? "#CCF4CD" : "white")};
  }

  &::after {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 1px solid ${(props) => (props.checked ? "#69c914" : "#0056b3")};
    border-radius: 50%;
    vertical-align: middle;
    position: relative;
    z-index: 0;
    opacity: ${(props) => (props.checked ? "1" : "0")};
    background-color: ${(props) => (props.checked ? "#CCF4CD" : "white")};
  }

  &:checked::before {
    border-color: #69c914;
    background-color: #69c914;
  }
`;

export const AddNewProductTextArea = styled.textarea`
  border: 1px solid #e8eaed;
  padding: 8px;
  border-radius: 12px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  color: ${colors.BLACK};
  resize: none;

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }

  padding: 15px;
`;
